export enum UpdateAction {
  REMOVE = "remove",
  ADD = "add",
  REPLACE = "replace",
  CLEAR = "clear",
}

export type Locale = "en" | "ar";

export enum Emirate {
  Dubai = "1",
  Sharjah = "4",
  "Abu Dhabi" = "6",
  Ajman = "5",
  "Umm Al Quwain" = "2",
  "Ras Al Khaimah" = "3",
}
